import React, { useEffect, useState } from "react";
import { Button } from "./Button";
import CookiesButton from "./CookiesButton";
const CookiesConsent = () => {
  const buttonAccept = "alle Cookies akzeptieren";
  const buttonRejected = "ablehnen";
  const buttonSettings = "Einstellungen";
  const [showBanner, setShowBanner] = useState(false);
  const [settingsClicked, setSettingsClicked] = useState(false);
  const [acceptClicked, setAcceptClicked] = useState(false);
  const measureId = "G-4XJ9L2RT5K";
  const setConsent = (consent) => {
    localStorage.setItem("cookieConsent", consent);
    if (consent === "accepted") {
      loadGoogleAnalytics();
    } else {
      revokeAnalyticsConsent();
    }
  };

  function getConsent() {
    return localStorage.getItem("cookieConsent");
  }
  function loadGoogleAnalytics() {
    if (window["ga-disable-" + measureId]) {
      window["ga-disable-" + measureId] = false;
    }

    if (document.querySelector(`script[src*="gtag/js?id=${measureId}"]`))
      return;

    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measureId}`;
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag(...args) {
        window.dataLayer.push(args);
      }
      window.gtag = gtag;

      gtag("js", new Date());
      gtag("config", measureId, {
        anonymize_ip: true,
      });
    };
  }
  function revokeAnalyticsConsent() {
    window["ga-disable-" + measureId] = true;
    const script = document.querySelector(
      `script[src*="gtag/js?id=${measureId}"]`
    );
    if (script) script.remove();

    deleteGACookies();
  }

  function deleteGACookies() {
    const cookies = document.cookie.split(";");
    for (const cookie of cookies) {
      const name = cookie.split("=")[0].trim();
      if (
        name.startsWith("_ga") ||
        name.startsWith("_gid") ||
        name.startsWith("_gat")
      ) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      }
    }
  }
  const acceptCookies = () => {
    setConsent("accepted");
    loadGoogleAnalytics();
    setShowBanner(false);
  };
  function getShowBanner(){
    setShowBanner(true);
  }
  function acceptTerms() {
    setAcceptClicked(!acceptClicked);
  }
  const rejectCookies = () => {
    setConsent("rejected");
    revokeAnalyticsConsent();
    setShowBanner(false);
    setAcceptClicked(false);
  };
  const settings = () => {
    setSettingsClicked(true);
  };
  function settingsAcceptCookies(){
    loadGoogleAnalytics();
    setShowBanner(false);
    setAcceptClicked(true);
    setConsent("accepted");
  }
  useEffect(() => {
    const consent = getConsent();
    setShowBanner(!consent);
    if (consent === "accepted") {
      loadGoogleAnalytics();
    }
  }, []);
  return (
    <div>
      {showBanner && (
        <div className="flex justify-center font-roboto items-center  fixed z-[1000] w-full md:text-[1.1rem] xl:text-[1.3rem] h-full bg-[rgba(255, 255, 255, 0.5)] top-0 left-0">
          {!settingsClicked ? (
            <div className="py-7 px-2  bg-bbf-black text-bbf-white sm:w-[90%] xl:w-2/4 h-auto flex justify-center md:w-[80%] items-center rounded-xl">
              <div className="flex justify-center items-center flex-col gap-5">
                <div className="flex justify-start items-center gap-5">
                  <img
                    src="https://media.bbf-bike.de/shop/documents/websites/checker-pig/images/cookie.png"
                    className="h-[40px] w-[40px] object-contain"
                    alt="cookie_image"
                  />
                  <div className="md:text-[1.4rem] xl:text-[1.9rem] ">Wir lieben Cookies!</div>
                </div>
                <div className="text-left px-[35px] w-[90%]">
                     Wir verwenden Cookies auf unserer Website. Einige sind für den Betrieb
        der Seite unverzichtbar, während andere uns helfen, die Website und Ihr
        Nutzungserlebnis zu verbessern.
                </div>
                <div className="flex justify-center items-center flex-col gap-7 w-4/5">
                  <div className="w-full" onClick={acceptCookies}>
                    <CookiesButton text={buttonAccept}/>
                  </div>

                  <div className="w-full" onClick={rejectCookies}>
                      <CookiesButton text={buttonRejected}/>
                  </div>

                  <div className="w-full" onClick={settings}>
                      <CookiesButton text={buttonSettings}/>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className=" font-lato py-7 px-2  bg-bbf-black text-bbf-white sm:w-[90%] xl:w-2/4 md:w-[80%] h-auto flex justify-center items-center rounded-xl">
              <div className="flex justify-center items-center flex-col gap-5">
                <div className="flex justify-start items-center gap-5">
                  <img
                    src="https://media.bbf-bike.de/shop/documents/websites/checker-pig/images/cookie.png"
                    className="h-[40px] w-[40px] object-contain"
                    alt="cookie_image"
                  />
                  <div className="md:text-[1.4rem] xl:text-[1.9rem]">Wir lieben Cookies!</div>
                </div>
                <div className="text-left w-[90%] md:text-[1.1rem] xl:text-[1.3rem]">
                     Hier finden Sie eine Übersicht aller verwendeten Cookies. Sie können Ihre
      Zustimmung für ganze Kategorien erteilen oder sich weitere Informationen
      anzeigen lassen und so nur bestimmte Cookies auswählen.
                </div>
                <div className="flex flex-col justify-center items-center gap-5 w-[90%] md:pt-[10px] xl:pt-[50px]">
                  <div className="flex justify-center items-center gap-5">
                    <div className="xl:text-[1.2rem] md:text-[1rem]">
                      Diese Website verwendet Google Analytics, um das
                      Nutzerverhalten zu analysieren. Dabei werden Cookies
                      gesetzt und Informationen können an Server von Google in
                      den USA übertragen werden. Die Speicherung und Auswertung
                      erfolgt nur mit Ihrer ausdrücklichen Einwilligung gemäß §
                      25 TTDSG i.V.m. Art. 6 Abs. 1 lit. a DSGVO.{" "}
                    </div>
                    <div className="flex justify-start items-center gap-5 text-[1.3rem]">
                      <div className="h-[26px] w-[50px] rounded-xl relative flex justify-center items-center bg-[#cfcccc]">
                        <div
                          className={`bg-[white] h-[22px] w-[22px] absolute rounded-[50%] cursor-pointer transition-all duration-500 ease-in-out
    ${acceptClicked ? "left-[50%] bg-[black]" : "left-[5%]"}
  `}
                          onClick={acceptTerms}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex justify-center gap-5 items-center w-[90%] flex-col">
                  <div className="w-full" onClick={settingsAcceptCookies}>
                      <CookiesButton text={buttonAccept}/>
                  </div>
                  <div className="w-full" onClick={rejectCookies}>
                      <CookiesButton text={buttonRejected}/>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {!showBanner && <div className="fixed bottom-2 left-2 z-50 cursor-pointer" onClick={getShowBanner}> 
        <img src="https://media.bbf-bike.de/shop/documents/websites/checker-pig/images/cookie.png" alt="cookie" className="object-contain sm:h-[20px] sm:w-[20px] md:h-[30px] md:w-[30px]"/>
        </div>}
    </div>
  );
};

export default CookiesConsent;
